@if (component) {
<div class="wrap">
    <!-- Main Title -->
    <h1 class="col-1 p-t-4 center"
        [sizeClass]="'XLM:h1, S:h3'"
        *iCms="'title' of component; skipEmpty: true"></h1>

    <!-- Two Column Layout -->
    <div [sizeClass]="'XLM:_content flex flex-justify-center flex-top, S:m-t-10'">

        <!-- Left Column: Delivery Selection -->
        <div class="c-5 c-12-s">
            <h3 class="h4 col-1 center"
                *iCms="'leftSectionTitle' of component; skipEmpty: true">
            </h3>

            <type-dropdown class="m-t-10 m-t-4-s"
                           [options]="countries()"
                           [value]="countryCode"
                           [placeholder]="'Search your country here' | translate"
                           (valueChange)="onCountrySelected($event)">
            </type-dropdown>

            @if (matchingConfiguration) {
            <p class="s2 col-1 m-t-10">{{ matchingConfiguration.custom_text }}</p>
            <p class="s2 col-1 m-t-8">{{'Delivery options:' | translate }}</p>

            @for (method of matchingConfigurationMethods; track $index) {
            <div class="_deliveryOption m-t-6 m-t-4-s">
                <div class="flex flex-top p2 ">
                    <p class="flex-grow">{{ method.title }}</p>
                    <price [value]="method.price"
                           [useFreeLabel]="true" />
                </div>
                <p class="p3 col-11 m-t-2 hide-empty">{{ getEstimatedDate(method) }}</p>
            </div>
            }
            }

            <p class="s2 col-1 m-t-8"
               *iCms="'returnsTitle' of component; skipEmpty: true"></p>
            <p class="p2 col-1 m-t-6"
               *iCms="'returnsDescription' of component; content: 'html'; skipEmpty: true"></p>

            @if (component.bottomItems?.length) {
            <div class="m-t-10 flex flex-column"
                 [style.gap.px]="10">
                @for (item of component.bottomItems; track $index) {
                <div [sizeClass]="'S:center'">
                    <href [link]="item.link">
                        <span class="linkLabel col-1"
                              *iCms="'copy' of item">
                        </span>
                    </href>
                </div>
                }
            </div>
            }
        </div>

        <!-- Right Column: Important Information -->
        <div class="c-5 c-12-s m-t-10-s">
            <h2 class="h4 col-1 center"
                *iCms="'rightSectionTitle' of component; skipEmpty: true"></h2>

            @if (component.informationItems?.length) {
            <div class="flex flex-column m-t-10 m-t-8-s m-t-8-m center"
                 [style.gap.px]="16">
                @for (item of component.informationItems; track $index; let last = $last) {
                <div class="p2 col-11"
                     *iCms="'text' of item; content:'html';">
                </div>
                @if (!last) {
                <div class="b-t b-col-41 _divider"></div>
                }
                }
            </div>
            }
        </div>
    </div>
</div>
}